import { TagsDetails } from "./tags";

export class MessagesFilter {
  messageText: string;
  direction: string;
  // references: string[];
  startDate: Date | null;
  endDate: Date | null;
  sources: string[];
  tagIds: TagsDetails[];
  recipient: string;
  status: string;
  page: number;
  size: number;
  sort: string;
  addressTypes?: string[];
  // campaignName: string;
  campaignId?: string;
  subscriberNumber?: string;

  constructor(filter?: MessagesFilter) {
    this.messageText = filter?.messageText ?? "";
    this.direction = filter?.direction ?? "ALL";
    // this.references = filter?.references ?? [];
    this.startDate = filter?.startDate ?? null;
    this.endDate = filter?.endDate ?? null;
    this.sources = filter?.sources ?? [];
    this.recipient = filter?.recipient ?? "";
    this.status = filter?.status ?? "ALL";
    this.page = filter?.page ?? 0;
    this.size = filter?.size ?? 0;
    this.sort = filter?.sort ?? "updatedTimestamp,desc";
    this.tagIds = [];
    this.addressTypes = filter?.addressTypes ?? [];
    // this.campaignName = "";
    this.campaignId = filter?.campaignId ?? "";
    this.subscriberNumber = filter?.subscriberNumber ?? "";
  }
}
